import Vue from 'vue'

export const decrypt = (message = '') => {
  const decryptedWords = Vue.CryptoJS.AES.decrypt(message, process.env.VUE_APP_KEY)
  return decryptedWords.toString(Vue.CryptoJS.enc.Utf8)
}

export const encrypt = (message = '') => {
  const encryptedWords = Vue.CryptoJS.AES.encrypt(message, process.env.VUE_APP_KEY)
  return encryptedWords.toString()
}
